import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Box, Button } from '@mui/material';
import {ADMIN_ROLE , useAuth} from "../context/AuthContext"
import { useAppContext } from '../context/AppContext';
const UserViewer = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { hasRole } = useAuth();

    const { getUserExtended, userExtended, } = useAppContext();

    const applications = [
        { name: 'LTV extension', balance: 100, code: "ltv-extension" },
        { name: 'LTV Reseal', balance: 200, code: "ltv-reseal" },
        { name: 'OneShot Signature', balance: 300, code: "oneshot-signature" },
        { name: 'OTP OneShot', balance: 150, code: "otp-oneshot" },
        { name: 'Signature', balance: 50, code: "signature" },
        { name: 'LTV Signature', balance: 350, code: "ltv-signature" },
        { name: 'Signcloud', balance: 75, code: "cryptoapi" },
        { name: 'TimeStamp', balance: 200, code: "timestamp" },
        { name: 'Verification', balance: 500, code: "validation" },
    ];

    useEffect(() => {
        getUserExtended(id)
    }
        , []);

    console.log(userExtended);

    const handleLoad = (app) => {
        navigate(`/user/${id}/${app.application_id}/load`);
    }

    const handleSend = (app) => {
        // Handle transfer action here
        // console.log(`Transferring from ${app.name}`);
        // <Route path="/user/:id/:app/transfer"
        navigate(`/user/${id}/${app.application_id}/transfer`);
    }

    const handleEdit = (app) => {
        // Navigate to the user edit page
        // /user/06cf7ccc-de4d-41ec-bd5e-35aebc3b3437/applications/ltv
        navigate(`/user/${id}/applications/${app.application_id}`);
    };

    const handleWithdraw = (app) => {
        // Handle withdraw action here
        // console.log(`Withdrawing from ${app.name}`);
        navigate(`/user/${id}/${app.application_id}/withdraw`);
    }

    const codeToName = (code) => {
        const app = applications.find(app => app.code === code);
        return app ? app.name : code;
    }

    return (
        <Box sx={{ p: 3 }}>
            <Grid container spacing={2} sx={{ mb: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            {userExtended && userExtended.user ? (
                                <>
                                    <Typography variant="h6" gutterBottom>User Information</Typography>
                                    <Typography>Name: {userExtended.user.first_name}</Typography>
                                    <Typography>Company: {userExtended.user.company}</Typography>
                                    <Typography>Email: {userExtended.user.email}</Typography>
                                </>
                            ) : (
                                <Typography variant="h6" gutterBottom>User Information</Typography>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Balance by Application</Typography>
                            <Grid container spacing={2}>
                                {userExtended.billing.map((app, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <Card>
                                            <CardContent>
                                                <Typography variant="subtitle1">{codeToName(app.application_id)}</Typography>
                                                {
                                                    app.type === "Prepaid" ? (
                                                        <Typography color='green'>Balance: {app.credit}</Typography>
                                                    ) : (
                                                        <></>
                                                    )
                                                }

                                                <Typography>Type Payment: {app.type}</Typography>
                                                {hasRole(ADMIN_ROLE) && (
                                                <Button variant="outlined" onClick={() => {
                                                    handleLoad(app);
                                                }} sx={{
                                                    marginBottom: 1,
                                                    width: '100%',
                                                }}>
                                                    Load</Button>
                                                )}
                                                

                                                <Button variant="outlined" onClick={() => {
                                                    handleSend(app);
                                                }} sx={{
                                                    marginBottom: 1,
                                                    width: '100%',
                                                }}>Send</Button>
                                                <Button variant="outlined" onClick={() => {
                                                    handleWithdraw(app);
                                                }} sx={{
                                                    marginBottom: 1,
                                                    width: '100%',
                                                }}>Withdraw</Button>
                                                <Button variant="outlined" onClick={() => {
                                                    // handleWithdraw(app);
                                                }} sx={{
                                                    marginBottom: 1,
                                                    width: '100%',
                                                }}>Disable</Button>
                                                {/* /user/06cf7ccc-de4d-41ec-bd5e-35aebc3b3437/applications/ltv */}
                                                <Button variant="outlined" onClick={() => {
                                                    handleEdit(app);
                                                }
                                                } sx={{
                                                    marginBottom: 1,
                                                    width: '100%',
                                                }}>More Info</Button>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default UserViewer;
